import { render, staticRenderFns } from "./favoritesList.vue?vue&type=template&id=8fd1bbc0&scoped=true&"
import script from "./favoritesList.vue?vue&type=script&lang=js&"
export * from "./favoritesList.vue?vue&type=script&lang=js&"
import style0 from "./favoritesList.vue?vue&type=style&index=0&id=8fd1bbc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd1bbc0",
  null
  
)

export default component.exports